// *******************************************************************************
// Login form validation
// *******************************************************************************

// **************************************************
// Save data to BE
// **************************************************
const axiosUpdateUserData = async (formData, formAction, cardindex) => {
  const nonce = await getNonceForAction(formAction);
  grecaptcha.ready(() => {
    grecaptcha.execute(localData.captchaSiteKey, { action: formAction }).then((token) => {
      const formDataInput = new FormData();
      formDataInput.append('action', formAction);
      formDataInput.append('nonce', nonce);
      formDataInput.append('card_index', cardindex || 'main');
      formDataInput.append('inputs', JSON.stringify(formData));
      formDataInput.append('lang', localData.lang);
      formDataInput.append('id', localData.id);
      formDataInput.append('token', token);
      axios
        .post(localData.apiURL, formDataInput, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          if (response.status === 200 && response.data.data.redirect === true) {
            window.location.reload();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    });
  });
};

const handleProfileSettingsForm = async (form, formAction) => {
  const passwordInpusts = form.querySelectorAll('input[type="password"]');
  const nonce = await getNonceForAction(formAction);
  const axiosSaveProfileDataAction = (formData) => {
    grecaptcha.ready(() => {
      grecaptcha.execute(localData.captchaSiteKey, { action: formAction }).then((token) => {
        const formErrorMessage = form.querySelector('.form-error-message');
        const formSuccessMessage = form.querySelector('.form-success-message');
        formErrorMessage.classList.remove('is-validation-failed');
        formSuccessMessage.classList.remove('show-thankyou');
        const formDataInput = new FormData();
        formDataInput.append('action', formAction);
        formDataInput.append('nonce', nonce);
        formDataInput.append('inputs', JSON.stringify(formData));
        formDataInput.append('lang', localData.lang);
        formDataInput.append('id', localData.id);
        formDataInput.append('token', token);
        axios
          .post(localData.apiURL, formDataInput, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((response) => {
            if (response.status === 200) {
              formSuccessMessage.innerHTML = response.data.data.msg;
              formSuccessMessage.classList.add('show-thankyou');
            }
            if (response.status === 200 && response.data.data.url) {
              setTimeout(() => {
                window.location.replace(response.data.data.url);
              }, 1500);
            }
            if (response.status !== 200) {
              if (err.response.data.data.msg) {
                formErrorMessage.innerHTML = err.response.data.data.msg;
              }
              formErrorMessage.classList.add('is-validation-failed');
            }
          })
          .catch((err) => {
            if (err.response.data.data.msg) {
              formErrorMessage.innerHTML = err.response.data.data.msg;
            }
            formErrorMessage.classList.add('is-validation-failed');
          });
      });
    });
  };

  const fv = FormValidation.formValidation(form, {
    locale: 'sl_SI',
    localization: FormValidation.locales.sl_SI,
    fields: {
      current_password: {
        validators: {
          notEmpty: {
            enabled: false,
          },
        },
      },
      new_password: {
        validators: {
          regexp: {
            regexp: /(?=.{8,})/g,
          },
          notEmpty: {
            enabled: false,
          },
        },
      },
      confirm_password: {
        validators: {
          identical: {
            compare() {
              return form.querySelector('[name="new_password"]').value;
            },
          },
          notEmpty: {
            enabled: false,
          },
        },
      },
    },
    plugins: {
      message: new FormValidation.plugins.Message({
        container: (field, element) => element.closest('.mod-input,.checkbox'),
      }),
      declarative: new FormValidation.plugins.Declarative({
        html5Input: true,
      }),
      trigger: new FormValidation.plugins.Trigger(),
      submitButton: new FormValidation.plugins.SubmitButton(),
    },
  })

    .on('core.element.validated', (e) => {
      // e.element presents the field element
      // e.valid indicates the field is valid or not

      // Get the field value
      const container = FormValidation.utils.closest(e.element, '.mod-input,.checkbox');
      FormValidation.utils.classSet(container, {
        'is-validation-failed': !e.valid,
      });
    })

    .on('core.form.valid', () => {
      const formData = {};
      form.querySelectorAll('input, textarea').forEach((input) => {
        if (input.type === 'checkbox') {
          formData[input.name] = input.checked;
        } else {
          formData[input.name] = input.value.trim();
        }
      });
      axiosSaveProfileDataAction(formData);
    });

  const map = [];
  passwordInpusts.forEach((input) => {
    map.push(input.value);
  });

  let enabled = !map.every((input) => input === '');

  passwordInpusts.forEach((el) => {
    el.addEventListener('input', (e) => {
      const password = e.target.value;
      if (password === '' && enabled) {
        enabled = false;
        fv.disableValidator('current_password').disableValidator('new_password').disableValidator('confirm_password');
      } else if (password !== '' && !enabled) {
        enabled = true;
        fv.enableValidator('current_password').enableValidator('new_password').enableValidator('confirm_password');
      }

      // Revalidate the confirmation password when the new password is changed
      if ((password !== '' && enabled) || (password === '' && !enabled)) {
        fv.revalidateField('current_password');
        fv.revalidateField('new_password');
        fv.revalidateField('confirm_password');
      }
    });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  const getCompanyDataFromVAT = async (targetModal, vatNumber, formAction) => {
    if (!vatNumber) {
      populateAddressList(targetModal, null);
    } else {
      const loadingElement = document.querySelector('.loading');
      dataIsLoading(loadingElement, true);
      try {
        const headerNonce = await getNonceForAction(formAction);
        const token = await new Promise((resolve, reject) => {
          grecaptcha.ready(() => {
            grecaptcha.execute(localData.captchaSiteKey, { action: formAction }).then(resolve).catch(reject);
          });
        });
        const dataInput = { action: formAction, vat: vatNumber, nonce: headerNonce, token };
        const response = await axios.post(localData.apiURL, dataInput);
        populateCompanyAddress(targetModal, response);
      } catch (error) {
        populateCompanyAddress(targetModal, null);
      } finally {
        dataIsLoading(loadingElement);
      }
    }
  };

  const populateCompanyAddress = (targetModal, response = null) => {
    const apiData = response?.data?.data;
    const elementsToPopulate = {
      company: apiData?.company || '',
      address_1: apiData?.address || '',
      postcode: apiData?.zip || '',
      city: apiData?.city || '',
    };

    Object.keys(elementsToPopulate).forEach((key) => {
      const elementToPopulate = targetModal.querySelector(`[name="${key}"]`);
      const inputWrap = elementToPopulate.closest('.mod-input');
      const errorElement = inputWrap.querySelector('.fv-plugins-message-container');

      elementToPopulate.value = elementsToPopulate[key];
      inputWrap.classList.remove('is-validation-failed');
      inputWrap.classList.toggle(
        'is-disabled',
        (response?.data.data.source === 'SAOP' && elementsToPopulate[key] !== '') || false,
      );
      if (errorElement) {
        errorElement.remove();
      }
    });
  };

  const accountSettingForm = document.getElementById('account-settings-form');
  const vatNumberField = document.querySelector('.mod-input__inner input[name="company_vat"]');
  if (vatNumberField) {
    vatNumberField.addEventListener('blur', (el) => {
      const targetModal = el.target.closest('.address-modal');
      getCompanyDataFromVAT(targetModal, vatNumberField.value, 'getCompanyData');
    });
  }
  if (accountSettingForm) {
    const formAction = accountSettingForm.querySelector('input#settings_action').value;

    handleProfileSettingsForm(accountSettingForm, formAction);
  }
});

// **************************************************
// Add and delete addresses
// **************************************************
let newAddressCard = null;
const addAddressBtns = document.querySelectorAll('.account-dashboard__address-add-btn');
addAddressBtns.forEach((addAddressBtn) => {
  addAddressBtn.addEventListener('click', () => {
    const parent = addAddressBtn.closest('.account-dashboard__address-row');
    const addButton = parent.querySelector('.account-dashboard__address-add-btn');
    const defaultItem = parent.querySelector('.default-item .account-dashboard__address-item');
    const clone = defaultItem.cloneNode(true);
    newAddressCard = clone;
    parent.append(clone);
    parent.appendChild(addButton);
    clone.querySelector('.open-address-modal').click();
  });
});

attachEvent('.delete-address-item', 'click', (ev) => {
  const parent = ev.target.closest('.account-dashboard__address-item');
  const cardIndex = parent.dataset.cardindex;
  const formAction = 'deleteUserShippingAddress';
  axiosUpdateUserData([], formAction, cardIndex);
  parent.classList.add('is-hidden');
  setTimeout(() => {
    parent.remove();
  }, 400);
});

// **************************************************
// Close modal
// **************************************************
const closeAddressesModal = () => {
  document.querySelectorAll('.address-modal.is-open-modal').forEach((el) => {
    newAddressCard = null;
    el.classList.remove('is-open-modal');
    toggleBodyScrollLock(false);
  });
};
attachEvent('.close-address-modal', 'click', (ev) => {
  ev.preventDefault();
  if (newAddressCard) {
    newAddressCard.remove();
    newAddressCard = null;
  }
  ev.target.closest('.address-modal').classList.remove('is-open-modal');
  toggleBodyScrollLock(false);
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    if (newAddressCard) {
      newAddressCard.remove();
      newAddressCard = null;
    }
    closeAddressesModal();
  }
});

// **************************************************
// Open modal, validate, paste info into address item
// **************************************************
attachEvent('.open-address-modal', 'click', (ev) => {
  ev.preventDefault();
  const loadingElement = document.querySelector('.loading');
  const modal = ev.target.closest('.account-dashboard__address-item').querySelector('.address-modal');
  modal.classList.add('is-open-modal');
  toggleBodyScrollLock(true);

  const addressForm = modal.querySelector('.address-modal__form');
  const postaInput = addressForm.querySelector('[name="posta"]');
  const cityInput = addressForm.querySelector('[name="mesto"]');

  const fv = FormValidation.formValidation(addressForm, {
    locale: 'sl_SI',
    localization: FormValidation.locales.sl_SI,
    fields: {},
    plugins: {
      message: new FormValidation.plugins.Message({
        container: (field, element) => element.closest('.mod-input'),
      }),
      declarative: new FormValidation.plugins.Declarative({
        html5Input: true,
      }),
      trigger: new FormValidation.plugins.Trigger(),
      submitButton: new FormValidation.plugins.SubmitButton(),
    },
  })
    .on('core.element.validated', (e) => {
      // e.element presents the field element
      // e.valid indicates the field is valid or not

      // Get the field value
      const value = fv.getElementValue(e.field, e.element);
      const container = FormValidation.utils.closest(e.element, '.mod-input');
      FormValidation.utils.classSet(container, { 'is-validation-failed': !e.valid && value === '' });
    })
    .on('core.form.valid', () => {
      const inputs = addressForm.querySelectorAll('.mod-input__field');
      inputs.forEach(() => {
        const addressItem = addressForm.closest('.account-dashboard__address-item');
        const placeholder = addressItem.querySelector('.account-dashboard__address-item__placeholder');
        if (placeholder) {
          placeholder.remove();
        }
      });
      const formData = {};
      const formAction = modal.querySelector('input#action').value;
      const cardIndex = modal.dataset.cardindex;
      modal.querySelectorAll('input, textarea').forEach((input) => {
        if (input.type === 'checkbox') {
          formData[input.name] = input.checked;
        } else {
          formData[input.name] = input.value.trim();
        }
      });
      axiosUpdateUserData(formData, formAction, cardIndex);
      closeAddressesModal();
      dataIsLoading(loadingElement, true);
    });
  initPostCodeHelper(fv, addressForm, false, postaInput, cityInput);
});
